import React, { useEffect, useState } from "react";
import { api, fmtUSD, fmtDate } from "../../lib/api";
import { toast, Toaster } from "sonner";
import { Check, X } from "lucide-react";

const AdminLoans = () => {
  const [apps, setApps] = useState([]);
  const [filter, setFilter] = useState("pending");
  const [busy, setBusy] = useState({});

  const load = async () => {
    const { data } = await api.get(`/admin/loan-applications${filter === "all" ? "" : `?status=${filter}`}`);
    setApps(data);
  };
  useEffect(() => { load(); }, [filter]);

  const decide = async (id, decision) => {
    setBusy((s) => ({ ...s, [id]: true }));
    try {
      await api.post(`/admin/loan-applications/${id}/decide`, { decision, reason: decision === "approved" ? "Approved by operator" : "Declined by operator" });
      toast.success(`Application ${decision}`);
      await load();
    } catch { toast.error("Failed"); }
    finally { setBusy((s) => ({ ...s, [id]: false })); }
  };

  const statusColor = (s) =>
    s === "approved" ? "text-[hsl(var(--primary))]" :
    s === "rejected" ? "text-[hsl(var(--destructive))]" :
    "text-[hsl(var(--accent))]";

  return (
    <div className="space-y-8">
      <Toaster richColors position="top-right" />
      <div className="flex items-end justify-between">
        <div>
          <div className="overline">Underwriting</div>
          <h1 className="font-display text-4xl mt-1">Loan desk</h1>
        </div>
        <div className="flex border border-[hsl(var(--border))]">
          {["pending", "approved", "rejected", "all"].map((k) => (
            <button key={k} onClick={() => setFilter(k)}
              className={`px-4 py-2 text-sm capitalize ${filter === k ? "bg-[hsl(var(--primary))] text-white" : "hover:bg-[hsl(var(--surface-alt))]"}`}
              data-testid={`filter-${k}`}>{k}</button>
          ))}
        </div>
      </div>

      <div className="bg-[hsl(var(--surface))] border border-[hsl(var(--border))]">
        <table className="w-full text-sm">
          <thead className="border-b border-[hsl(var(--border))]">
            <tr className="text-left">
              <th className="overline py-3 px-4">Submitted</th>
              <th className="overline py-3 px-4">Applicant</th>
              <th className="overline py-3 px-4">Product</th>
              <th className="overline py-3 px-4 text-right">Amount</th>
              <th className="overline py-3 px-4">Term</th>
              <th className="overline py-3 px-4">Purpose</th>
              <th className="overline py-3 px-4">Status</th>
              <th className="overline py-3 px-4">Actions</th>
            </tr>
          </thead>
          <tbody>
            {apps.map((a) => (
              <tr key={a.id} className="border-b border-[hsl(var(--border))]" data-testid={`loan-${a.id}`}>
                <td className="py-3 px-4 font-mono text-xs">{fmtDate(a.created_at)}</td>
                <td className="py-3 px-4">{a.user_name}</td>
                <td className="py-3 px-4">{a.product_name}</td>
                <td className="py-3 px-4 text-right font-mono">{fmtUSD(a.amount)}</td>
                <td className="py-3 px-4">{a.term_months} mo</td>
                <td className="py-3 px-4">{a.purpose}</td>
                <td className={`py-3 px-4 capitalize font-medium ${statusColor(a.status)}`}>{a.status}</td>
                <td className="py-3 px-4">
                  {a.status === "pending" && (
                    <div className="flex gap-1">
                      <button onClick={() => decide(a.id, "approved")} disabled={busy[a.id]}
                        className="bg-[hsl(var(--primary))] text-white p-1.5 hover:opacity-90"
                        data-testid={`approve-${a.id}`}>
                        <Check className="w-4 h-4" />
                      </button>
                      <button onClick={() => decide(a.id, "rejected")} disabled={busy[a.id]}
                        className="border border-[hsl(var(--border))] p-1.5 hover:bg-[hsl(var(--surface-alt))]"
                        data-testid={`reject-${a.id}`}>
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
            {apps.length === 0 && (
              <tr><td colSpan={8} className="py-12 text-center text-[hsl(var(--text-muted))]">No applications.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminLoans;
